// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ed-container {
    width: 100%;
    position: relative;
}

.ed-content {
    width: 100%;
    transition: opacity 1s ease;
    opacity: 1;
}

    .ed-content.detached {
        opacity: 0;
    }
`, "",{"version":3,"sources":["webpack://./src/Controls/css/ElementDetacher.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,UAAU;AACd;;IAEI;QACI,UAAU;IACd","sourcesContent":[".ed-container {\r\n    width: 100%;\r\n    position: relative;\r\n}\r\n\r\n.ed-content {\r\n    width: 100%;\r\n    transition: opacity 1s ease;\r\n    opacity: 1;\r\n}\r\n\r\n    .ed-content.detached {\r\n        opacity: 0;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
